// 生成分数段分类 (230-290, 每5分一段，从高到低排列)
export const categories = (() => {
  const scoreRanges = []
  for (let start = 230; start < 290; start += 5) {
    const end = start + 5
    scoreRanges.push({
      id: `${start}-${end}`,
      name: `${start}-${end}分`,
      min: start,
      max: end
    })
  }
  // 反转数组，使分数段从高到低排列
  scoreRanges.reverse()
  return [
    { id: 'all', name: '全部', min: 0, max: 1000 },
    ...scoreRanges
  ]
})()

// 示例视频数据 - 学生视频展示
export const videoData = [
  {
    id: 1,
    title: '学生作品展示 - 230分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/409eff/ffffff?text=230分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    duration: '15:30',
    views: 12500,
    date: '2024-01-15',
    score: 232,
    studentName: '张三',
    campus: '北京校区',
    musicEducationScore: 232.50,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 2,
    title: '学生作品展示 - 238分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/67c23a/ffffff?text=238分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    duration: '28:45',
    views: 18900,
    date: '2024-01-20',
    score: 238,
    studentName: '李四',
    campus: '上海校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 238.75,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 3,
    title: '学生作品展示 - 242分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/e6a23c/ffffff?text=242分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    duration: '22:10',
    views: 9600,
    date: '2024-02-01',
    score: 242,
    studentName: '王五',
    campus: '广州校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 242.30,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 4,
    title: '学生作品展示 - 247分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/f56c6c/ffffff?text=247分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
    duration: '35:20',
    views: 15200,
    date: '2024-02-10',
    score: 247,
    studentName: '赵六',
    campus: '深圳校区',
    musicEducationScore: 247.80,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 5,
    title: '学生作品展示 - 252分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/909399/ffffff?text=252分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
    duration: '26:50',
    views: 21300,
    date: '2024-02-15',
    score: 252,
    studentName: '孙七',
    campus: '北京校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 252.60,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 6,
    title: '学生作品展示 - 257分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/409eff/ffffff?text=257分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
    duration: '31:15',
    views: 17800,
    date: '2024-02-20',
    score: 257,
    studentName: '周八',
    campus: '上海校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 257.40,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 7,
    title: '学生作品展示 - 263分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/67c23a/ffffff?text=263分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
    duration: '24:40',
    views: 11200,
    date: '2024-03-01',
    score: 263,
    studentName: '吴九',
    campus: '广州校区',
    musicEducationScore: 263.25,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 8,
    title: '学生作品展示 - 268分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/e6a23c/ffffff?text=268分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
    duration: '19:25',
    views: 14500,
    date: '2024-03-05',
    score: 268,
    studentName: '郑十',
    campus: '深圳校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 268.90,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 9,
    title: '学生作品展示 - 273分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/f56c6c/ffffff?text=273分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    duration: '20:15',
    views: 16800,
    date: '2024-03-10',
    score: 273,
    studentName: '钱十一',
    campus: '北京校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 273.15,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 10,
    title: '学生作品展示 - 278分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/909399/ffffff?text=278分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    duration: '25:30',
    views: 19200,
    date: '2024-03-15',
    score: 278,
    studentName: '陈十二',
    campus: '上海校区',
    musicEducationScore: 278.70,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 11,
    title: '学生作品展示 - 283分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/409eff/ffffff?text=283分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    duration: '18:45',
    views: 15600,
    date: '2024-03-20',
    score: 283,
    studentName: '林十三',
    campus: '广州校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 283.45,
    vocalPerformanceScore: 0,
    tags: ['作品展示', '学习成果']
  },
  {
    id: 12,
    title: '学生作品展示 - 288分',
    description: '这是一位学生的优秀作品展示视频。',
    fullDescription: '在这个视频中，展示了学生在学习过程中的优秀作品。视频包含了完整的项目演示和讲解，展现了学生的学习成果和技能提升。',
    thumbnail: 'https://via.placeholder.com/640x360/67c23a/ffffff?text=288分作品',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
    duration: '22:20',
    views: 20100,
    date: '2024-03-25',
    score: 288,
    studentName: '黄十四',
    campus: '深圳校区',
    musicEducationScore: 0,
    instrumentPerformanceScore: 0,
    vocalPerformanceScore: 288.85,
    tags: ['作品展示', '学习成果']
  }
]

